
export const BackofficeAPI = {
  attendance: {
    list: '/attendance/report',
    matrix: '/attendance/matrix',
    detail: '/attendance/detail',
    dashboard: '/attendance/dashboard',
  }
}


